import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import ArticleAds from "./ArticleAds";
const Services = ({ showHeader = true }) => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <div>
      <div className="p-folio__hero" data-aos="fade-down">
        <h1 className="p-folio__title">Our Services</h1>
        <p className="p-folio__subtitle">Know More About Our Services</p>

        {/* CATEGORY SELECTOR TABS */}
      </div>

      {/* MOBILE DEVELOPMENT */}
      <section id="mobile" className="service-section" data-aos="fade-up">
        <div className="service-left" data-aos="fade-right">
          <span className="whyXTag">SERVICES</span>
          <h2 className="service-title">Mobile Development</h2>

          <ul className="service-list">
            <li data-aos="fade-up" data-aos-delay="100">
              <i className="bi bi-apple"></i>
              IOS Development
            </li>

            <li data-aos="fade-up" data-aos-delay="200">
              <i className="bi bi-android2"></i>
              Android Development
            </li>

            <li data-aos="fade-up" data-aos-delay="300">
              <i className="bi bi-phone"></i>
              Flutter Development
            </li>
            <li data-aos="fade-up" data-aos-delay="400">
              <i className="bi bi-badge-vr"></i>
              AR/VR Development
            </li>
          </ul>
        </div>

        <div className="service-right" data-aos="fade-left">
          <h2>Mobile App Development</h2>

          <p>
            We provide powerful mobile app solutions to help businesses grow
            digitally with innovative and scalable applications.
          </p>

          <Link to="/portfolio#mobile" className="explore-btn">
            Explore →
          </Link>
          <div
            className="service-image"
            data-aos="zoom-in"
            data-aos-delay="300"
          >
            <img src="/images/1.png" alt="mobile-app" />
          </div>
        </div>
      </section>
      <div style={{ margin: "40px 0" }}>
        <ArticleAds />
      </div>
      {/* WEB DEVELOPMENT */}
      <section id="web" className="service-section reverse" data-aos="fade-up">
        <div className="service-right" data-aos="fade-left">
          <span className="whyXTag">SERVICES</span>
          <h1 className="service-title">Web Development</h1>

          <ul className="service-list">
            <li data-aos="fade-up" data-aos-delay="100">
              <i className="bi bi-filetype-php"></i>
              PHP Web Development
            </li>

            <li data-aos="fade-up" data-aos-delay="200">
              <i className="bi bi-code-slash"></i>
              React Js Development
            </li>

            <li data-aos="fade-up" data-aos-delay="300">
              <i className="bi bi-node-plus"></i>
              Node Js Development
            </li>

            <li data-aos="fade-up" data-aos-delay="400">
              <i className="bi bi-globe"></i>
              .Net Development
            </li>
          </ul>
        </div>

        <div className="service-right" data-aos="fade-right">
          <h2>Web Development</h2>

          <p>
            We build modern, scalable and responsive websites tailored to your
            business needs, helping you improve performance and deliver a
            seamless user experience.
          </p>

          <Link to="/portfolio#web" className="explore-btn">
            Explore →
          </Link>

          <div className="service-image" data-aos="zoom-in">
            <img
              src="images/web-development-banner.png"
              alt="web development"
            />
          </div>
        </div>
      </section>
      <div style={{ margin: "40px 0" }}>
        <ArticleAds />
      </div>
      {/* UI UX DESIGN */}
      <section id="uiux" className="service-section" data-aos="fade-up">
        <div className="service-left" data-aos="fade-right">
          <span className="whyXTag">SERVICES</span>
          <h2 className="service-title">UI/UX & Graphic Design</h2>

          <ul className="service-list">
            <li data-aos="fade-up" data-aos-delay="100">
              <i className="bi bi-palette"></i>
              User Interface (UI) Design
            </li>

            <li data-aos="fade-up" data-aos-delay="200">
              <i className="bi bi-bezier"></i>
              User Experience (UX) Design
            </li>

            <li data-aos="fade-up" data-aos-delay="300">
              <i className="bi bi-grid-3x3"></i>
              Prototyping
            </li>

            {/* <li>
              <i className="bi bi-brush"></i>
              Illustration
            </li> */}

            <li data-aos="fade-up" data-aos-delay="400">
              <i className="bi bi-vector-pen"></i>
              Logo / Icon Design
            </li>
            {/* 
            <li>
              <i className="bi bi-film"></i>
              Motion / Animation
            </li> */}
          </ul>
        </div>
        <div className="service-right" data-aos="fade-left">
          <h2>UI/UX Design</h2>

          <p>
            We design visually stunning, engaging, meaningful & user-friendly
            customer experiences for your target audience.
          </p>

          <Link to="/portfolio#uiux" className="explore-btn">
            Explore →
          </Link>

          <div className="service-image" data-aos="zoom-in">
            <img src="/images/uiuxbanner.png" alt="uiux design" />
          </div>
        </div>
      </section>
      <div style={{ margin: "40px 0" }}>
        <ArticleAds />
      </div>
      {/* DIGITAL MARKETING */}
      <section
        id="marketing"
        className="service-section reverse"
        data-aos="fade-up"
      >
        <div className="service-right" data-aos="fade-left">
          <span className="whyXTag">SERVICES</span>
          <h2 className="service-title">Digital Marketing</h2>

          <ul className="service-list">
            <li data-aos="fade-up" data-aos-delay="100">
              <i className="bi bi-search"></i>
              Search Engine Optimization (SEO)
            </li>

            <li data-aos="fade-up" data-aos-delay="200">
              <i className="bi bi-megaphone"></i>
              Social Media Marketing
            </li>

            <li data-aos="fade-up" data-aos-delay="300">
              <i className="bi bi-google"></i>
              Google Ads Campaign
            </li>

            <li data-aos="fade-up" data-aos-delay="400">
              <i className="bi bi-instagram"></i>
              Facebook & Instagram Ads
            </li>

            <li data-aos="fade-up" data-aos-delay="500">
              <i className="bi bi-graph-up"></i>
              Analytics & Reporting
            </li>
          </ul>
        </div>
        <div className="service-right" data-aos="fade-right">
          <h2>Digital Marketing</h2>

          <p>
            We deliver powerful digital marketing strategies to grow your brand
            online. From SEO optimization to social media and paid advertising,
            we help businesses achieve measurable results.
          </p>
          <div className="service-image" data-aos="zoom-in">
            <img src="/images/4.png" alt="Digital Marketing" />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
